import React from 'react'
import { StyleSheet, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Hashtags, Icon, Text } from '@components'
import { Theme } from '@theme'
import { useLanguage } from '@context'
import { getComponentsStyles } from './styles'

export type AboutCategory = {
  title: string
  tags: string[]
}

export type AboutSectionProps = {
  title: string
  categories: AboutCategory[]
  noEdit?: boolean
  onEdit?: () => void
}

export const AboutSection = ({
  title,
  categories,
  noEdit = false,
  onEdit,
}: AboutSectionProps): React.ReactElement => {
  const theme = useTheme()
  const { t } = useLanguage()
  const styles = getStyle(theme)
  const componentsStyles = getComponentsStyles(theme)

  return (
    <View style={styles.container}>
      <View style={styles.topContainer}>
          <Text type="bodyBold" color={theme.colors.primary} style={styles.title}>
            {title}
          </Text>
          {!noEdit && <Icon
            name="edit"
            color={theme.colors.greyBlue}
            size={theme.iconSize.medium}
            containerStyle={styles.editIcon}
            onPress={onEdit}
          />}
        </View>
      <View style={categories.length === 0? styles.sectionContainerBordered : styles.sectionContainer}>
        {categories.map((category, categoryIndex) => (
          <View 
            key={categoryIndex} 
            style={[
              styles.categoryContainer,
              categoryIndex === categories.length - 1 && styles.lastCategoryContainer
            ]}
          >
            <Text type="bodyBold" color={theme.colors.secondary}>
              {category.title}
            </Text>
            <Hashtags hashtags={category.tags} />
          </View>
        ))}
        {categories.length === 0 && 
        <View style={componentsStyles.emptyState}>
          <Text type="bodySmall" color={theme.colors.greyBlue} style={componentsStyles.emptyText}>
            {t('profileScreen.noDataAdded')}
          </Text>
        </View>}
      </View>
    </View>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    container: {
      marginHorizontal: theme.spacing.xl,
    },
    topContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: theme.spacing.sm,
    },
    title: {
    },
    editIcon: {
      padding: theme.spacing.sm,
    },
    sectionContainer: {
      marginBottom: theme.spacing.lg,
    },
    sectionContainerBordered: {
      marginBottom: theme.spacing.lg,
      borderWidth: 1,
      borderColor: theme.colors.grey,
      borderRadius: theme.border.large,
      paddingVertical: theme.spacing.lg,
    },
    categoryContainer: {
      marginBottom: theme.spacing.xs,
      borderRadius: 10,
      padding: 15,
      gap: 10,
      backgroundColor: 'rgba(0, 0, 0, 0.03)',
    },
    encounterContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      borderRadius: 10,
      padding: 10,
      gap: 10,
      backgroundColor: '#edf4fd',
      marginBottom: theme.spacing.lg
    },
    lastCategoryContainer: {
      marginBottom: 0,
    },
    categoryTitle: {
      marginBottom: theme.spacing.xxs,
    },
  }) 